import React from 'react'
import PropTypes from 'prop-types'
import { Pane, Text, majorScale } from 'evergreen-ui'

const EmptyState = ({ searchTerm }) => (
  <Pane textAlign="center" padding={majorScale(5)}>
    <Text wordWrap="break-word">0 results found for "{searchTerm}"</Text>
  </Pane>
)

EmptyState.propTypes = {
  searchTerm: PropTypes.string.isRequired
}

export default EmptyState
